module.exports = "<div [cxWait]=\"(ready | async)\">\n    <div class=\"keypad-interactions\">\n      <prg-select-button-interaction iconClass=\"keypad\" [device]=\"(device | async)\" [button]=\"(button | async)\" [events]=\"(events | async)\"\n        (selected)=\"interactionSelected($event)\"></prg-select-button-interaction>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-keypads/select-keypad-interaction/select-keypad-interaction.component.html
// module id = 1568
// module chunks = 2